import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SettingTitle from '../../../common/components/UI/Title/SettingTitle';
import TabSelection from './TabSelection';
import ConfigurationSet from '../ConfigurationSet';
import RuleSet from '../RuleSet';
import './App.scss';
import '../../../common-client2/src/style.scss';
import 'rsuite/dist/rsuite.min.css';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css'

function App() {
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'settings' });

    useEffect(() => {
        document.title = t('pageTitle.admin');
    }, []);
    
    const tabsOptions = Object.freeze({
        ConfigurationSet: 0,
        RuleSet: 1,
    });
    const adminPages = [
        {
            id: tabsOptions.ConfigurationSet,
            label: t('tabs.configurationSet'),
        },
        {
            id: tabsOptions.RuleSet,
            label: t('tabs.ruleSet'),
        },
    ];
    const [adminPageSelected, setAdminPageSelected] = React.useState(tabsOptions.ConfigurationSet);

    return (
        <>
            <SettingTitle
                subtitleText={t('adminPageSubHeader')}
                titleText={t('adminPageHeader')}
                reverse={true}
            />
            <div className="admin-tabs-container">
                <TabSelection
                    tabs={adminPages}
                    handleTabChange={setAdminPageSelected}
                />
            </div>
            <div className="admin-content">
                {adminPageSelected === tabsOptions.ConfigurationSet && (
                    <ConfigurationSet />
                )}
                {adminPageSelected === tabsOptions.RuleSet && (
                    <RuleSet />
                )}
            </div>
        </>
    );
}
export default (App);
